import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import {
  Badge,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import Widget from "../../components/Widget/Widget";
import {
  API_TIMEOUT,
  CARI_DTSEN_LIKE,
  CARI_DATA_MISKIN_LIKE_DTKS,
  GET_DESA,
  GET_KECAMATAN,
  HISTORI_BANTUAN_TERPADU,
  NIRLABA_AKUMULASI,
  NIRLABA_LEMBAGA,
  NIRLABA_PENERIMA,
  NIRLABA_PROGRAM,
} from "../../utils/index";
import { numberWithCommas } from "../../utils/func";
import {
  getMitraLembagaId,
  getStoredUser,
  isAdminMitra,
} from "../../utils/adminMitra";

const currentYear = new Date().getFullYear();
const listTahun = Array.from({ length: currentYear - 2018 + 1 }, (_, i) =>
  String(2018 + i)
).reverse();

function leftJoin(array1, array2, joinKey) {
  return array1.map((item1) => {
    const matchedItems = (array2 || []).filter(
      (item2) => String(item2[joinKey]) === String(item1[joinKey])
    );
    return { ...item1, matchedItems };
  });
}

function normalisasiDtsen(row) {
  return {
    ...row,
    NIK: row.NIK,
    noKK: row.noKK || row.NOKK || "",
    jenisKelamin: row.jenisKelamin || row.jenis_kelamin || "",
    tanggalLahir: row.tanggalLahir || row.tanggal_lahir || row.dob,
    desa: row.desa || "",
    kecamatan: row.kecamatan || "",
    desilKesejahteraan: row.desilKesejahteraan ?? row.desil_nasional,
    sumberData: "dtsen",
  };
}

function normalisasiDukcapil(row) {
  return {
    ...row,
    NIK: row.NIK,
    noKK: row.noKK || row.NOKK || "",
    jenisKelamin: row.jenisKelamin || row.jenis_kelamin || "",
    tanggalLahir: row.tanggalLahir || row.tanggal_lahir,
    desa: row.desa || row.alamat || "",
    kecamatan: row.kecamatan || "",
    desilKesejahteraan: null,
    sumberData: "datadukcapil",
  };
}

function nilaiDesil(raw) {
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

function formatDob(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (!s) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.substring(0, 10);
  const parts = s.split(/[/\s]/);
  if (parts.length >= 3 && parts[2].length === 4) {
    return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
  }
  return s.substring(0, 10);
}

const PenerimaNirlabaForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [nama, setNama] = useState("");
  const [nik, setNik] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [noKK, setNoKK] = useState("");
  const [desa, setDesa] = useState("");
  const [kecamatan, setKecamatan] = useState("");
  const [nilaiUang, setNilaiUang] = useState("");
  const [catatan, setCatatan] = useState("");
  const [idIndividu, setIdIndividu] = useState("");
  const [idKeluarga, setIdKeluarga] = useState("");
  const [tahun, setTahun] = useState(String(currentYear));
  const [lembaga, setLembaga] = useState([]);
  const [program, setProgram] = useState([]);
  const [idLembaga, setIdLembaga] = useState("");
  const [namaLembaga, setNamaLembaga] = useState("");
  const [bantuan, setBantuan] = useState("");
  const [sumberDana, setSumberDana] = useState("");
  const [listDesa, setListDesa] = useState([]);
  const [listKecamatan, setListKecamatan] = useState([]);
  const [desaPilihan, setDesaPilihan] = useState([]);
  const [kataCari, setKataCari] = useState("");
  const [cariLoading, setCariLoading] = useState(false);
  const [hasilCari, setHasilCari] = useState([]);
  const [modalCari, setModalCari] = useState(false);
  const [modalHistori, setModalHistori] = useState(false);
  const [listHistori, setListHistori] = useState([]);
  const [akumulasi, setAkumulasi] = useState(null);
  const [desil, setDesil] = useState(null);
  const [sumberData, setSumberData] = useState("");
  const [modalDukcapil, setModalDukcapil] = useState(false);
  const [detailDukcapil, setDetailDukcapil] = useState(null);

  useEffect(() => {
    axios.get(GET_DESA, { timeout: API_TIMEOUT }).then((res) => {
      setListDesa(res.data?.data || []);
    });
    axios.get(GET_KECAMATAN, { timeout: API_TIMEOUT }).then((res) => {
      const data = res.data?.data || [];
      setListKecamatan(data.map((item, i) => ({ id: i, value: item.kecamatan })));
    });
    axios.get(NIRLABA_LEMBAGA, { timeout: API_TIMEOUT }).then((res) => {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      const lid = getMitraLembagaId(user);
      let data = (res.data?.data || []).filter((x) => Number(x.aktif) !== 0);
      if (isAdminMitra(user) && lid) {
        data = data.filter((x) => Number(x.id) === lid);
        setIdLembaga(String(lid));
        if (data[0]) setNamaLembaga(data[0].nama_lembaga);
      }
      setLembaga(data);
    });
  }, []);

  useEffect(() => {
    axios
      .get(NIRLABA_PROGRAM, { params: { tahun }, timeout: API_TIMEOUT })
      .then((res) => setProgram(res.data?.data || []))
      .catch(() => setProgram([]));
  }, [tahun]);

  useEffect(() => {
    if (!id) return;
    axios
      .get(NIRLABA_PENERIMA + "/" + id, { timeout: API_TIMEOUT })
      .then((res) => {
        const row = res.data?.data?.[0];
        if (!row) return;
        setNama(row.nama || "");
        setNik(row.nik || "");
        setDob(formatDob(row.dob));
        setGender(row.gender || "");
        setNoKK(row.noKK || "");
        setDesa(row.desa || "");
        setKecamatan(row.kecamatan || "");
        setNilaiUang(row.nilaiUang || "");
        setCatatan(row.catatan || "");
        setTahun(String(row.tahun || currentYear));
        setIdLembaga(String(row.id_lembaga || ""));
        setNamaLembaga(row.nama_lembaga || "");
        setBantuan(row.bantuan || "");
        setSumberDana(row.sumber_dana || "");
        setIdIndividu(row.idIndividu || "");
        setIdKeluarga(row.idKeluarga || "");
      })
      .catch((err) => alert(err));
  }, [id]);

  const ubahKecamatan = (kec) => {
    setKecamatan(kec);
    const filtered = listDesa.filter((item) => item.kecamatan === kec);
    setDesaPilihan(filtered);
    setDesa("");
  };

  const programLembaga = program.filter(
    (item) => String(item.id_lembaga) === String(idLembaga)
  );

  const pilihLembaga = (val) => {
    setIdLembaga(val);
    const found = lembaga.find((item) => String(item.id) === String(val));
    setNamaLembaga(found ? found.nama_lembaga : "");
    setBantuan("");
    setSumberDana("");
  };

  const pilihProgram = (namaProg) => {
    setBantuan(namaProg);
    const found = programLembaga.find((item) => item.bantuan === namaProg);
    if (found) {
      setSumberDana(found.sumber_dana || "NGO");
    }
  };

  const bukaDetailDukcapil = (item) => {
    setDetailDukcapil(item);
    setModalCari(false);
    setModalDukcapil(true);
  };

  const terapkanHasilCari = (data) => {
    setHasilCari(data);
    const dariDukcapil = data[0]?.sumberData === "datadukcapil";
    if (dariDukcapil) {
      if (data.length === 1) {
        bukaDetailDukcapil(data[0]);
        return;
      }
      setModalCari(true);
      return;
    }
    const cariNik = /^\d{16}$/.test(kataCari.trim());
    if (cariNik && data.length === 1) {
      isiFormDariOrang(data[0]);
      return;
    }
    setModalCari(true);
  };

  const cariMasyarakat = () => {
    if (!kataCari.trim()) {
      swal("Info", "Masukkan NIK atau nama", "info");
      return;
    }
    const payload = {
      item: kataCari.trim(),
      desa: desa || "",
      kecamatan: kecamatan || "",
      kolomcari: /^\d{16}$/.test(kataCari.trim()) ? "NIK" : "nama",
    };
    setCariLoading(true);
    axios({
      method: "post",
      url: CARI_DTSEN_LIKE,
      timeout: API_TIMEOUT,
      data: payload,
    })
      .then((res) => {
        const dataDtsen = (res.data?.data || []).map(normalisasiDtsen);
        if (dataDtsen.length > 0) {
          terapkanHasilCari(dataDtsen);
          return Promise.resolve();
        }
        return axios({
          method: "post",
          url: CARI_DATA_MISKIN_LIKE_DTKS,
          timeout: API_TIMEOUT,
          data: payload,
        }).then((resDd) => {
          const dataDd = (resDd.data?.data || []).map(normalisasiDukcapil);
          terapkanHasilCari(dataDd);
        });
      })
      .catch((err) => alert(err))
      .finally(() => setCariLoading(false));
  };

  const kosongkanForm = () => {
    setNama("");
    setNik("");
    setDob("");
    setGender("");
    setNoKK("");
    setDesa("");
    setKecamatan("");
    setDesaPilihan([]);
    setNilaiUang("");
    setCatatan("");
    setIdIndividu("");
    setIdKeluarga("");
    setIdLembaga("");
    setNamaLembaga("");
    setBantuan("");
    setSumberDana("");
    setKataCari("");
    setHasilCari([]);
    setAkumulasi(null);
    setDesil(null);
    setSumberData("");
    setDetailDukcapil(null);
    setListHistori([]);
    setModalCari(false);
    setModalDukcapil(false);
    setModalHistori(false);
  };

  const isiFormDariOrang = (item) => {
    setNama(item.nama || "");
    setNik(item.NIK || "");
    setNoKK(item.noKK || "");
    setGender(item.jenisKelamin || "");
    setDob(formatDob(item.tanggalLahir || item.dob));
    setDesa(item.desa || desa);
    setKecamatan(item.kecamatan || kecamatan);
    setIdIndividu(item.id || "");
    setDesil(nilaiDesil(item.desilKesejahteraan ?? item.desil_nasional));
    setSumberData(item.sumberData || "dtsen");
    setModalCari(false);
    setModalDukcapil(false);
    ambilHistori(item.NIK);
    ambilAkumulasi(item.NIK, item.noKK);
  };

  const ambilHistori = (nikVal) => {
    if (!nikVal) return;
    axios({
      method: "post",
      url: HISTORI_BANTUAN_TERPADU,
      timeout: API_TIMEOUT,
      data: { kolom: "nik", data: nikVal },
    })
      .then((res) => {
        const tahunList = listTahun.map((t, i) => ({ id: i, tahun: t }));
        setListHistori(leftJoin(tahunList, res.data?.data || [], "tahun"));
        setModalHistori(true);
      })
      .catch((err) => alert(err));
  };

  const ambilAkumulasi = (nikVal, nokkVal) => {
    axios({
      method: "post",
      url: NIRLABA_AKUMULASI,
      timeout: API_TIMEOUT,
      data: { nik: nikVal, noKK: nokkVal, tahun },
    })
      .then((res) => setAkumulasi(res.data?.data || null))
      .catch(() => setAkumulasi(null));
  };

  const simpan = async (e) => {
    e.preventDefault();
    if (!nik || nik.length !== 16) {
      swal("NIK tidak valid", "NIK harus 16 digit", "warning");
      return;
    }
    if (!idLembaga || !bantuan) {
      swal("Lengkapi data", "Lembaga dan program wajib dipilih", "warning");
      return;
    }
    if (!id) {
      const cek = await axios.post(
        NIRLABA_PENERIMA + "/check",
        { nik, bantuan, tahun },
        { timeout: API_TIMEOUT }
      );
      if ((cek.data?.data || []).length) {
        swal(
          "Tidak bisa",
          "NIK ini sudah tercatat pada program dan tahun yang sama",
          "warning"
        );
        return;
      }
    }
    const payload = {
      nama,
      nik,
      dob,
      gender,
      noKK,
      desa,
      kecamatan,
      nilaiUang,
      catatan,
      tahun,
      bantuan,
      id_lembaga: idLembaga,
      nama_lembaga: namaLembaga,
      sumber_dana: sumberDana || "NGO",
      idIndividu,
      idKeluarga,
      status: "",
      kelompok: "",
    };
    const req = id
      ? axios.patch(NIRLABA_PENERIMA + "/" + id, payload, { timeout: API_TIMEOUT })
      : axios.post(NIRLABA_PENERIMA, payload, { timeout: API_TIMEOUT });
    req
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Penerima bantuan mitra tersimpan", "success");
          if (id) {
            dispatch(push("/admin/nirlaba/penerima"));
          } else {
            kosongkanForm();
          }
        } else {
          swal("Gagal", res.data?.message || "Gagal simpan", "error");
        }
      })
      .catch((err) =>
        swal("Gagal", err.response?.data?.message || err.message, "error")
      );
  };

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">
          {id ? "Edit penerima mitra" : "Input penerima bantuan mitra"}
        </h2>
      </div>
      <Widget>
        <Form onSubmit={simpan}>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Cari masyarakat (DTSEN)
            </Label>
            <Col md={8} className="d-flex">
              <Input
                placeholder="NIK atau nama"
                value={kataCari}
                onChange={(e) => setKataCari(e.target.value)}
              />
              <Button
                color="info"
                type="button"
                className="ml-2"
                onClick={cariMasyarakat}
                disabled={cariLoading}
              >
                {cariLoading ? <Spinner size="sm" /> : "Cari"}
              </Button>
              {nik ? (
                <Button
                  color="secondary"
                  type="button"
                  className="ml-2"
                  onClick={() => ambilHistori(nik)}
                >
                  Histori terpadu
                </Button>
              ) : null}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Tahun
            </Label>
            <Col md={8}>
              <Input type="select" value={tahun} onChange={(e) => setTahun(e.target.value)}>
                {listTahun.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Lembaga
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={idLembaga}
                onChange={(e) => pilihLembaga(e.target.value)}
                required
                disabled={isAdminMitra(getStoredUser())}
              >
                <option value="">Pilih lembaga</option>
                {lembaga.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nama_lembaga}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Program tahun ini
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={bantuan}
                onChange={(e) => pilihProgram(e.target.value)}
                required
              >
                <option value="">Pilih program</option>
                {programLembaga.map((item) => (
                  <option key={item.id} value={item.bantuan}>
                    {item.bantuan}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Nama
            </Label>
            <Col md={8}>
              <Input value={nama} onChange={(e) => setNama(e.target.value)} required />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              NIK
            </Label>
            <Col md={8}>
              <Input value={nik} onChange={(e) => setNik(e.target.value)} required maxLength={16} />
            </Col>
          </FormGroup>
          {desil != null ? (
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Desil kesejahteraan
              </Label>
              <Col md={8} className="d-flex align-items-center">
                <Badge color={desil <= 2 ? "danger" : desil <= 4 ? "warning" : "info"}>
                  Desil {desil}
                </Badge>
                <span className="ml-2 text-muted">sumber DTSEN</span>
              </Col>
            </FormGroup>
          ) : sumberData === "datadukcapil" ? (
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Desil kesejahteraan
              </Label>
              <Col md={8} className="d-flex align-items-center">
                <Badge color="secondary">Tidak ada desil</Badge>
                <span className="ml-2 text-muted">ditemukan di Dukcapil</span>
              </Col>
            </FormGroup>
          ) : null}
          <FormGroup row>
            <Label md={3} className="text-md-right">
              No KK
            </Label>
            <Col md={8}>
              <Input value={noKK} onChange={(e) => setNoKK(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Jenis kelamin
            </Label>
            <Col md={8}>
              <Input value={gender} onChange={(e) => setGender(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Tanggal lahir
            </Label>
            <Col md={8}>
              <Input type="date" value={dob} onChange={(e) => setDob(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Kecamatan
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={kecamatan}
                onChange={(e) => ubahKecamatan(e.target.value)}
              >
                <option value="">Pilih kecamatan</option>
                {listKecamatan.map((item) => (
                  <option key={item.id} value={item.value}>
                    {item.value}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Desa
            </Label>
            <Col md={8}>
              <Input type="select" value={desa} onChange={(e) => setDesa(e.target.value)}>
                <option value="">Pilih desa</option>
                {(desaPilihan.length ? desaPilihan : listDesa)
                  .filter((item) => !kecamatan || item.kecamatan === kecamatan)
                  .map((item, i) => (
                    <option key={i} value={item.desa}>
                      {item.desa}
                    </option>
                  ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Nilai bantuan
            </Label>
            <Col md={8}>
              <Input
                type="number"
                value={nilaiUang}
                onChange={(e) => setNilaiUang(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Catatan
            </Label>
            <Col md={8}>
              <Input type="textarea" value={catatan} onChange={(e) => setCatatan(e.target.value)} />
            </Col>
          </FormGroup>
          {akumulasi ? (
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Akumulasi tahun {tahun}
              </Label>
              <Col md={8}>
                <div>
                  Pemerintah: <b>Rp {numberWithCommas(akumulasi.pemerintah || 0)}</b>
                  {Number(akumulasi.pemerintah) >= 50000000 ? (
                    <Badge color="danger" className="ml-2">
                      &ge; 50 juta (aturan pemerintah)
                    </Badge>
                  ) : (
                    <Badge color="success" className="ml-2">
                      di bawah 50 juta
                    </Badge>
                  )}
                </div>
                <div>
                  NGO/Swasta: <b>Rp {numberWithCommas(akumulasi.nirlaba || 0)}</b>
                </div>
                <div>
                  Gabungan: <b>Rp {numberWithCommas(akumulasi.gabungan || 0)}</b>
                </div>
                <small className="text-muted">
                  Batas Rp 50 juta hanya berlaku untuk dana pemerintah; data mitra tetap bisa
                  disimpan.
                </small>
              </Col>
            </FormGroup>
          ) : null}
          <FormGroup row>
            <Label md={3} />
            <Col md={8}>
              <Button color="primary" type="submit" className="mr-2">
                Simpan
              </Button>
              <Button
                color="secondary"
                type="button"
                onClick={() => dispatch(push("/admin/nirlaba/penerima"))}
              >
                Batal
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </Widget>

      <Modal isOpen={modalCari} toggle={() => setModalCari(false)} size="lg">
        <ModalHeader>
          {hasilCari[0]?.sumberData === "datadukcapil"
            ? "Hasil pencarian Dukcapil (tidak ada di DTSEN)"
            : "Hasil pencarian DTSEN"}
        </ModalHeader>
        <ModalBody>
          {hasilCari.length === 0 ? (
            <div>Tidak ada data di DTSEN maupun Dukcapil</div>
          ) : (
            hasilCari.map((item) => (
              <div
                key={item.NIK}
                className="d-flex justify-content-between align-items-center border-bottom py-2"
              >
                <div>
                  <div>
                    <b>{item.nama}</b>{" "}
                    <Badge color={item.sumberData === "datadukcapil" ? "secondary" : "success"}>
                      {item.sumberData === "datadukcapil" ? "Dukcapil" : "DTSEN"}
                    </Badge>
                  </div>
                  <small>
                    NIK {item.NIK} · {item.desa || "-"} · {item.kecamatan || "-"}
                    {nilaiDesil(item.desilKesejahteraan) != null
                      ? ` · Desil ${item.desilKesejahteraan}`
                      : ""}
                  </small>
                </div>
                {item.sumberData === "datadukcapil" ? (
                  <Button size="sm" color="warning" onClick={() => bukaDetailDukcapil(item)}>
                    Detail
                  </Button>
                ) : (
                  <Button size="sm" color="primary" onClick={() => isiFormDariOrang(item)}>
                    Pilih
                  </Button>
                )}
              </div>
            ))
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setModalCari(false)}>Tutup</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalDukcapil} toggle={() => setModalDukcapil(false)} size="lg">
        <ModalHeader toggle={() => setModalDukcapil(false)}>
          Data ditemukan di Dukcapil
        </ModalHeader>
        <ModalBody>
          <div
            className="alert alert-warning"
            role="alert"
            style={{ marginBottom: 16 }}
          >
            Data ini <b>tidak ditemukan pada DTSEN / desil kesejahteraan</b>.
            Identitas di bawah berasal dari Dukcapil. Pastikan orang yang benar
            sebelum mengisi form penerima bantuan mitra.
          </div>
          {detailDukcapil ? (
            <Widget className="widget-p-md">
              <Row className="mb-2">
                <Col md={4}>Nama</Col>
                <Col md={8}>
                  <b style={{ color: "#c0392b" }}>{detailDukcapil.nama || "-"}</b>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>NIK</Col>
                <Col md={8}>{detailDukcapil.NIK || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>No KK</Col>
                <Col md={8}>{detailDukcapil.noKK || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Jenis kelamin</Col>
                <Col md={8}>{detailDukcapil.jenisKelamin || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Tempat / tanggal lahir</Col>
                <Col md={8}>
                  {[detailDukcapil.tempatLahir, formatDob(detailDukcapil.tanggalLahir)]
                    .filter(Boolean)
                    .join(" / ") || "-"}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Alamat / desa</Col>
                <Col md={8}>{detailDukcapil.desa || detailDukcapil.alamat || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Kecamatan</Col>
                <Col md={8}>{detailDukcapil.kecamatan || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Hubungan dengan KK</Col>
                <Col md={8}>
                  {detailDukcapil.hubunganKK || detailDukcapil.hubungan_keluarga || "-"}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Status kawin</Col>
                <Col md={8}>{detailDukcapil.statusKawin || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Pendidikan</Col>
                <Col md={8}>{detailDukcapil.pendidikan || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>Pekerjaan</Col>
                <Col md={8}>{detailDukcapil.pekerjaan || "-"}</Col>
              </Row>
              <Row>
                <Col md={4}>Desil DTSEN</Col>
                <Col md={8}>
                  <Badge color="secondary">Tidak tercatat (bukan data DTSEN)</Badge>
                </Col>
              </Row>
            </Widget>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDukcapil(false)}>
            Batal
          </Button>
          <Button
            color="primary"
            onClick={() => detailDukcapil && isiFormDariOrang(detailDukcapil)}
          >
            Input
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalHistori} toggle={() => setModalHistori(false)}>
        <ModalHeader>Histori bantuan terpadu</ModalHeader>
        <ModalBody>
          <ul className="list-group">
            {listHistori.map((item) => (
              <li className="list-group-item" key={item.id}>
                <b>{item.tahun}</b>
                {item.matchedItems.length === 0 ? (
                  <div className="text-muted">Tidak ada bantuan</div>
                ) : (
                  item.matchedItems.map((row, idx) => (
                    <div key={idx}>
                      <Badge color={row.asal === "nirlaba" ? "info" : "primary"} className="mr-1">
                        {row.asal === "nirlaba" ? "NGO/Swasta" : "Pemerintah"}
                      </Badge>
                      {row.nama_lembaga ? <span>{row.nama_lembaga} · </span> : null}
                      <code>{row.bantuan}</code>{" "}
                      {row.nilaiUang ? "Rp " + numberWithCommas(row.nilaiUang) : ""}
                    </div>
                  ))
                )}
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setModalHistori(false)}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PenerimaNirlabaForm;
